//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import {
  IInstagramCompetitorsMediaResponse,
} from '@apis/instagram-competitors/instagramCompetitorsApiModel';
import {
  IInstagramCompetitor,
  ITrackedSourceCompetitor,
} from '@instagram-account/redux/competitors/instagramCompetitorsModel';
import { Serialized } from '@utils/types/Serialized';

export const deserializeCompetitorMediaDates = (
  response: Serialized<IInstagramCompetitorsMediaResponse>,
): IInstagramCompetitorsMediaResponse => ({
  ...response,
  media: response.media.map((item) => ({
    ...item,
    postedTime: item.postedTime ? new Date(item.postedTime) : undefined,
  })),
});

export const toTrackedSourceCompetitor = (competitor: IInstagramCompetitor): ITrackedSourceCompetitor => ({
  businessUserId: competitor.id,
  username: competitor.username,
});
